import img from './img';
import audio from './audio';
import dataConfig from './gameData.config.js';

var config = {
  author: 'MZ',
  engine: 'coloring',
  gameConfig: dataConfig,
  title: [
    {
      text: 'Pokoloruj rysunek. Kliknij w wybrany kolor, a potem w ten element na rysunku, który chcesz pokolorować. Z jakiej baśni pochodzi ta ilustracja?',
      audio: 'games/page016_game9/audio/z16c2-3-4.mp3',
    },
  ],
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

export default config;
